import { EnergyRatingIndicator } from 'enova-frontend-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { EnergimerkeV2023 } from '../../../types/energimerke';

interface Props {
  energimerke: EnergimerkeV2023;
}

export const EnergikarakterV2023: FC<Props> = ({ energimerke }) => {
  const { t } = useTranslation();

  if (!energimerke?.energikarakter || !energimerke?.oppvarmingskarakter) {
    return <EnergyRatingIndicator title={t('noEnergyRating')} />;
  }

  const karakterTitle = `${t('energyLabel.heatingGrade', {
    context: energimerke.oppvarmingskarakter
  })} ${energimerke.energikarakter}`;

  return (
    <EnergyRatingIndicator
      heatingGrade={energimerke.oppvarmingskarakter}
      energyGrade={energimerke.energikarakter}
      title={karakterTitle}
    />
  );
};
